<template>
	<div>
		<div class="p-d-flex p-flex-column p-ai-center">
			<i
				class="pi pi-check-circle"
				style="font-size: 3rem !important; color: green"
			></i>
			<h1 class="p-text-center p-pt-2 p-text-bold">
				Thank You For Your Payment
			</h1>

			<table class="p-d-flex p-text-left p-jc-center">
				<tbody>
					<tr>
						<td
							class="p-p-2"
							style="
								font-weight: bold;
								border: none;
								font-family: revert;
								border-right: 1px solid #b3b8ba;
							"
						>
							Status
						</td>
						<td class="p-p-2" style="border: none">
							{{ store.formSubmissionData.status }}
						</td>
					</tr>

					<tr v-if="store.formSubmissionData.merchantId">
						<td
							class="p-p-2"
							style="
								font-weight: bold;
								border: none;
								border-right: 1px solid #b3b8ba;
							"
						>
							Transaction ID
						</td>
						<td class="p-p-2" style="border: none">
							{{ store.formSubmissionData.merchantId }}
						</td>
					</tr>

					<tr>
						<td
							class="p-p-2"
							style="
								font-weight: bold;
								border: none;
								border-right: 1px solid #b3b8ba;
							"
						>
							Total
						</td>
						<td class="p-p-2" style="border: none">
							${{
								store.formSubmissionData && store.formSubmissionData.amount
									? store.formSubmissionData.amount.toFixed(2)
									: "0.00"
							}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";

export default {
	name: "EndForm",
	setup() {
		const store = useFormDataStore();

		return {
			store,
		};
	},
};
</script>

<style lang="scss" scoped></style>
